const getErrorFromAxios = (error) => {
  if (error && error.response && error.response.data && error.response.data.error) {
    return error.response.data.error;
  }

  return null;
};

export default getErrorFromAxios;
